let markers = [];

document.querySelectorAll(".store-locator-google-map").forEach(async (mapElement, sectionIndex) => {
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  const cards = mapElement.closest(".store-locator").querySelectorAll(".store-locator-card");
  const storeLongitude = Array.from(mapElement.closest(".store-locator").querySelectorAll(".store-locator-card__longitude")).map(item => item.textContent);
  const storeLatitude = Array.from(mapElement.closest(".store-locator").querySelectorAll(".store-locator-card__latitude")).map(item => item.textContent);
  const coordinateTitle = Array.from(mapElement.closest(".store-locator").querySelectorAll(".store-locator-card__coordinate-title")).map(item => item.textContent).map(item => item.replace(/([A-Z])/g, ' $1').trim());
  const coordinateAddress = Array.from(mapElement.closest(".store-locator").querySelectorAll(".store-locator-card__address")).map(item => item.textContent);
  const coordinateHours = Array.from(mapElement.closest(".store-locator").querySelectorAll(".store-locator-card__opening-hour")).map(item => item.innerHTML);
  const coordinateButtons = Array.from(mapElement.closest(".store-locator").querySelectorAll(".store-locator-card__actions")).map(item => item.innerHTML);

  const mapZoomLevel = Number(mapElement.dataset.mapZoomLevel) || 4;
  const mapZoomLevelUnit = mapZoomLevel <= 18 ? 3 : 0;

  const locations = [];

  for (let i = 0; i < storeLongitude.length; i++) {
    const lat = Number(storeLatitude[i]);
    const lng = Number(storeLongitude[i]);
    const title = coordinateTitle[i];
    const address = coordinateAddress[i];
    const tooltip = address && !title ? address : title;

    if (lat && lng) {
      locations.push([
        `<b>${tooltip}</b><br/><a href="https://maps.google.com/?q=${lat},${lng}" target="_blank" style="text-decoration: underline;">Location</a>`,
        lat,
        lng
      ]);
    }
  }

  const minLongitude = Math.min(...storeLongitude);
  const minLatitude = Math.min(...storeLatitude);
  const maxLongitude = Math.max(...storeLongitude);
  const maxLatitude = Math.max(...storeLatitude);

  const centerLatitude = (minLatitude + maxLatitude) / 2;
  const centerLongitude = (minLongitude + maxLongitude) / 2;

  const map = new Map(mapElement, {
    zoom: mapZoomLevel,
    center: { lat: centerLatitude, lng: centerLongitude },
    scrollwheel: true,
    gestureHandling: "greedy",
    disableDefaultUI: true,
    backgroundColor: "#89b4f8",
    mapId: "4504f8b37365c3d0"
  });

  const infowindow = new google.maps.InfoWindow({
    maxWidth: 200
  });

  const pinIcon = {
    url: mapElement.dataset.mapPinIcon
  };

  const setMapClickHandler = (item, i) => {
    item.addEventListener("click", function () {
      map.panTo(new google.maps.LatLng(locations[i][1], locations[i][2]));
      map.setZoom(mapZoomLevel + mapZoomLevelUnit);
    });
  };

  for (let i = 0; i < locations.length; i++) {
    setMapClickHandler(cards[i], i);

    const customMarker = document.createElement("div");
    const customMarkerLabel = document.createElement("div");
    const customMarkerPoint = document.createElement("div");
    const openingHoursLabel = document.createElement("div");
    const buttonsLabel = document.createElement("div");

    customMarker.className = "store-locator__map--custom-marker";
    customMarker.setAttribute("id", `store-locator__map--custom-marker--${sectionIndex}-${i}`);

    customMarkerLabel.className = "store-locator__map--custom-marker--label";
    customMarkerLabel.textContent = coordinateTitle[i];

    customMarkerPoint.className = "store-locator__map--custom-marker--point";
    openingHoursLabel.className = "store-locator__map--custom-marker--hours";
    openingHoursLabel.innerHTML = coordinateHours[i];

    buttonsLabel.className = "store-locator__map--custom-marker--buttons";
    buttonsLabel.innerHTML = coordinateButtons[i];

    customMarker.appendChild(customMarkerLabel);
    customMarker.appendChild(customMarkerPoint);
    customMarkerLabel.appendChild(openingHoursLabel);
    customMarkerLabel.appendChild(buttonsLabel);

    const marker = new AdvancedMarkerElement({
      position: new google.maps.LatLng(locations[i][1], locations[i][2]),
      map,
      content: customMarker
    });

    markers.push(marker);

    google.maps.event.addListener(marker, "click", () => {
      let newLatLng = window.innerWidth <= 750
        ? new google.maps.LatLng(locations[i][1] - 5, locations[i][2])
        : new google.maps.LatLng(locations[i][1], locations[i][2]);

      map.panTo(newLatLng);

      mapElement.closest(".store-locator").querySelectorAll(".store-locator__map--custom-marker")
        .forEach(item => item.classList.remove("store-locator__map--custom-marker--active"));

      document.getElementById(`store-locator__map--custom-marker--${sectionIndex}-${i}`)
        .classList.add("store-locator__map--custom-marker--active");

      const mapWithSearch = mapElement.closest(".store-locator__map-layout")?.classList.contains("store-locator__map-layout--with-search");
      if (!mapWithSearch || (window.innerWidth < 750)) {
        cards.forEach(card => card.style.display = "none");
        cards[i].style.display = "block";
      }
    });

    map.addListener("click", () => {
      mapElement.closest(".store-locator").querySelectorAll(".store-locator__map--custom-marker")
        .forEach(item => item.classList.remove("store-locator__map--custom-marker--active"));

      cards.forEach(card => card.removeAttribute("style"));
    });

    const crossButtons = mapElement.closest(".store-locator").querySelectorAll(".store-locator-card__cross");
    crossButtons.forEach(button => {
      button.addEventListener("click", () => {
        mapElement.closest(".store-locator").querySelectorAll(".store-locator__map--custom-marker")
          .forEach(item => item.classList.remove("store-locator__map--custom-marker--active"));

        cards.forEach(card => card.removeAttribute("style"));
      });
    });
  }
});
